export default "__VITE_ASSET__Dnc2hEX8__"